export const PAISES_TELEFONO_PRINCIPALES = [
  { nombre: 'Argentina',      bandera: '🇦🇷', codigo: '+54'  },
  { nombre: 'España',         bandera: '🇪🇸', codigo: '+34'  },
  { nombre: 'Italia',         bandera: '🇮🇹', codigo: '+39'  },
  { nombre: 'Francia',        bandera: '🇫🇷', codigo: '+33'  },
  { nombre: 'Alemania',       bandera: '🇩🇪', codigo: '+49'  },
  { nombre: 'Rumania',        bandera: '🇷🇴', codigo: '+40'  },
  { nombre: 'Austria',        bandera: '🇦🇹', codigo: '+43'  },
  { nombre: 'Estados Unidos', bandera: '🇺🇸', codigo: '+1'   },
  { nombre: 'Brasil',         bandera: '🇧🇷', codigo: '+55'  },
  { nombre: 'Uruguay',        bandera: '🇺🇾', codigo: '+598' },
  { nombre: 'Chile',          bandera: '🇨🇱', codigo: '+56'  },
  { nombre: 'Colombia',       bandera: '🇨🇴', codigo: '+57'  },
  { nombre: 'México',         bandera: '🇲🇽', codigo: '+52'  },
];

export const PAISES_TELEFONO_OTROS = [
  { nombre: 'Australia',      bandera: '🇦🇺', codigo: '+61'  },
  { nombre: 'Bélgica',        bandera: '🇧🇪', codigo: '+32'  },
  { nombre: 'Bolivia',        bandera: '🇧🇴', codigo: '+591' },
  { nombre: 'Canadá',         bandera: '🇨🇦', codigo: '+1'   },
  { nombre: 'China',          bandera: '🇨🇳', codigo: '+86'  },
  { nombre: 'Croacia',        bandera: '🇭🇷', codigo: '+385' },
  { nombre: 'Ecuador',        bandera: '🇪🇨', codigo: '+593' },
  { nombre: 'Grecia',         bandera: '🇬🇷', codigo: '+30'  },
  { nombre: 'Honduras',       bandera: '🇭🇳', codigo: '+504' },
  { nombre: 'Hungría',        bandera: '🇭🇺', codigo: '+36'  },
  { nombre: 'Israel',         bandera: '🇮🇱', codigo: '+972' },
  { nombre: 'Japón',          bandera: '🇯🇵', codigo: '+81'  },
  { nombre: 'Marruecos',      bandera: '🇲🇦', codigo: '+212' },
  { nombre: 'Noruega',        bandera: '🇳🇴', codigo: '+47'  },
  { nombre: 'Países Bajos',   bandera: '🇳🇱', codigo: '+31'  },
  { nombre: 'Paraguay',       bandera: '🇵🇾', codigo: '+595' },
  { nombre: 'Perú',           bandera: '🇵🇪', codigo: '+51'  },
  { nombre: 'Polonia',        bandera: '🇵🇱', codigo: '+48'  },
  { nombre: 'Portugal',       bandera: '🇵🇹', codigo: '+351' },
  { nombre: 'Reino Unido',    bandera: '🇬🇧', codigo: '+44'  },
  { nombre: 'Rusia',          bandera: '🇷🇺', codigo: '+7'   },
  { nombre: 'Serbia',         bandera: '🇷🇸', codigo: '+381' },
  { nombre: 'Suecia',         bandera: '🇸🇪', codigo: '+46'  },
  { nombre: 'Suiza',          bandera: '🇨🇭', codigo: '+41'  },
  { nombre: 'Turquía',        bandera: '🇹🇷', codigo: '+90'  },
  { nombre: 'Ucrania',        bandera: '🇺🇦', codigo: '+380' },
  { nombre: 'Venezuela',      bandera: '🇻🇪', codigo: '+58'  },
];

export function paisTelefonoTranslationKey(nombre) {
  return String(nombre || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, '_');
}
